<!-- ============================================================== -->
<!-- Topbar header - style you can find in pages.scss -->
<!-- ============================================================== -->
<header class="topbar">
  <!-- <div class="covid-banner">
    <span class="mdi mdi-stethoscope"></span>
    <span><strong>COVID-19</strong></span>
    <span class="separator"> | </span>
    <a href="https://blog.brightcities.city/bright-cities-mapeia-solucoes-inteligentes-para-frear-a-covid-19/?lang=pt-br">{{'covid/info' | translate}}</a> 
  </div> -->
  <div class="d-flex justify-content-center">
    <div class="container">
      <nav class="navbar top-navbar navbar-toggleable-sm navbar-light">
        <div class="navbar-collapse justify-content-center flex-wrap">
          <a [routerLink]="['/']" class="navbar-brand">
            <!-- Logo icon -->
            <h1 class="titleHide">
              <span>BRIGHT CITIES</span>
              <!--You can put here icon as well // <i class="wi wi-sunset"></i> //-->
              <!-- Dark Logo icon -->
              <img alt="homepage" class="dark-logo" src="../assets/images/logowhite-upgrade.svg"/>
            </h1>
            <!--End Logo icon -->
          </a>
          <button (click)="menuToggle()" aria-expanded="false" aria-label="Toggle navigation" class="navbar-toggler"
                  type="button">
            <i class="fal fa-bars"></i>
          </button>
          <ul class="navbar-nav">
            <li class="nav-item">
              <a [routerLink]="['/about-us']" [translate]="'navigation/about-us'" class="nav-link"
                 routerLinkActive="router-link-active">Quem Somos</a>
            </li>
            <li class="nav-item">
              <a [routerLink]="['/cities-diagnosis']" [translate]="'navigation/cities-diagnosis'" class="nav-link"
                 routerLinkActive="router-link-active">Diagnóstico de Cidades</a>
            </li>
            <li class="nav-item has-submenu">
              <a class="nav-link" routerLinkActive="router-link-active">{{'navigation/solutions-marketplace' | translate}}&nbsp;<i
                class="fal fa-angle-down"></i></a>
              <ul class="navbar-nav submenu">
                <li class="nav-item">
                  <a [routerLink]="['/smart-cities-solutions']" class="nav-link">{{'navigation/access-the-marketplace' |
                      translate}}</a>
                </li>
                <li class="nav-item">
                  <a [routerLink]="['/solution-marketplace']" class="nav-link">{{'navigation/about-marketplace' |
                      translate}}</a>
                </li>

              </ul>
            </li>
            <li class="nav-item has-submenu">
              <a [routerLink]="['/our-services', 'public-administrator']" class="nav-link"
                 routerLinkActive="router-link-active">{{'navigation/our-services' | translate}} <i
                class="fal fa-angle-down"></i></a>
              <ul class="navbar-nav submenu">
                <li class="nav-item">
                  <a [routerLink]="['/our-services', 'public-administrator']" class="nav-link"><i
                    class="fal fa-angle-right"></i> {{'create-account/PUBLIC_ADMINISTRATOR' | translate}}</a>
                </li>
                <li class="nav-item">
                  <a [routerLink]="['/our-services', 'solution-provider']" class="nav-link"><i
                    class="fal fa-angle-right"></i> {{'our-services/solution-provider' | translate}}</a>
                </li>
                <li class="nav-item">
                  <a [routerLink]="['/our-services', 'private-organization']" class="nav-link"><i
                    class="fal fa-angle-right"></i> {{'landing/public-private' | translate}}</a>
                </li>
                <li class="nav-item">
                  <a [routerLink]="['/our-services', 'connected-citizen']" class="nav-link"><i
                    class="fal fa-angle-right"></i> {{'our-services/connected-citizens' | translate}}</a>
                </li>
              </ul>
            </li>
            <li class="nav-item">
              <a [translate]="'navigation/blog'" class="nav-link"
                 href="https://blog.brightcities.city{{ (language.current().flag == 'us') ? '' : '/pt-br/' }}">Blog</a>
            </li>
            <li class="nav-item">
              <a [routerLink]="['/certification']" [translate]="'navigation/certification'" class="nav-link"
                 >Certificação</a>
            </li>
            <li class="nav-item">
              <a [routerLink]="['/faq']"
                 class="nav-link">FAQ</a>
            </li>
            <li class="nav-item has-submenu">
                <a [translate]="'navigation/rankings'" class="nav-link">Rankings&nbsp;<i
                        class="fal fa-angle-down"></i></a>
                <ul class="navbar-nav submenu">
                    <li class="nav-item">
                        <a class="nav-link"
                           href="https://blog.brightcities.city{{ (language.current().flag == 'us') ? '/ranking-cidades-sustentaveis-2026/' : '/pt-br/ranking-cidades-sustentaveis-2026/' }}"><i
                                class="fal fa-angle-right"></i> 2026</a>
                    </li>
                    <li class="nav-item">
                        <a class="nav-link"
                           href="https://blog.brightcities.city{{ (language.current().flag == 'us') ? '/ranking-de-cidades-sustentaveis-2025/' : '/pt-br/ranking-de-cidades-sustentaveis-2025/' }}"><i
                                class="fal fa-angle-right"></i> 2025</a>
                    </li>
                    <li class="nav-item">
                        <a class="nav-link"
                           href="https://blog.brightcities.city{{ (language.current().flag == 'us') ? '/ranking-de-cidades-sustentaveis-2024/' : '/pt-br/ranking-de-cidades-sustentaveis-2024/' }}"><i
                                class="fal fa-angle-right"></i> 2024</a>
                    </li>
                    <li class="nav-item">
                        <a class="nav-link"
                           href="https://blog.brightcities.city{{ (language.current().flag == 'us') ? '/ranking-bright-cities-2023/' : '/pt-br/ranking-bright-cities-2023/' }}"><i
                                class="fal fa-angle-right"></i> 2023</a>
                    </li>
                </ul>
            </li>
          </ul>
          <!-- ============================================================== -->
          <!-- User profile and search -->
          <!-- ============================================================== -->
          <ul *ngIf="!loggedIn" class="navbar-nav my-lg-0">
            <li class="nav-item">
              <a (click)="onLogin()" [translate]="'navigation/login'" class="nav-link">Login</a>
            </li>
            <li class="nav-item">
              <a [routerLink]="['/create-account']" [translate]="'navigation/register'" class="btnWhite">Register</a>
            </li>
            <li class="nav-item-language">
              <button class="language-box">
                <span (click)="changeLanguage(i, lang.flag)" *ngFor="let lang of languages; let i = index"
                      ngClass="flag-icon flag-icon-{{ lang.flag }}"></span>
              </button>
            </li>
          </ul>
          <!-- ============================================================== -->
          <!-- User profile and search -->
          <!-- ============================================================== -->
          <div *ngIf="loggedIn" class="navbar-collapse auto-width justify-content-center">
            <!-- ============================================================== -->
            <!-- toggle and nav items -->
            <!-- ============================================================== -->
            <!-- ============================================================== -->
            <!-- User profile -->
            <!-- ============================================================== -->
            <ul class="navbar-nav my-lg-0">
              <li class="nav-item-language">
                <button class="language-box">
                  <span (click)="changeLanguage(i, lang.flag)" *ngFor="let lang of languages; let i = index"
                        ngClass="flag-icon flag-icon-{{ lang.flag }}"></span>
                  <!-- <span [translate]="'navigation/change'">Change</span> -->
                </button>
              </li>
              <li class="nav-item dropdown">
                <a aria-expanded="false" aria-haspopup="true"
                   class="nav-link nav-link-username dropdown-toggle waves-effect waves-dark" data-toggle="dropdown">
                  <i class="ion ion-ios-person i24 white"></i> <span
                  [innerHTML]="'navigation/hello' | translate:{value: user.firstName}">Hello,
                  {{user.firstName}}</span>
                  <i class="ion-ios-arrow-down medIco white"></i>
                </a>
                <div class="dropdown-menu dropdown-menu-right animated dropdown-user-container">
                  <ul class="dropdown-user">

                    <ng-container *ngIf="user.isPublicAdministrator()">
                      <!-- City Switcher (when multiple cities) -->
                      <li class="city-switcher" *ngIf="showCitySwitcher" (click)="$event.stopPropagation()">
                        <div class="city-selector">
                          <div class="city-selected" (click)="focusCitySearch()">
                            <span class="selected-name">{{ selectedCity?.name }}</span>
                            <span class="selected-region" *ngIf="selectedCity?.region">&nbsp;- {{ selectedCity?.region }}</span>
                            <i class="material-icons">arrow_drop_down</i>
                          </div>
                          <div class="citiesSearch" *ngIf="showCitySearch">
                            <input
                              type="text"
                              [(ngModel)]="citySearchTerm"
                              (input)="filterCitiesInput()"
                              (blur)="blurCitySearch()"
                              placeholder="{{ 'navigation/search-city' | translate }}">
                            <ul>
                              <li *ngFor="let city of filteredCitiesList"
                                  [class.selected]="city.id === selectedCity?.id"
                                  (click)="selectCity(city)">
                                <a>
                                  <span class="dark01">{{ city.name }}</span>
                                  <small class="grey01" *ngIf="city.region">{{ city.region }}</small>
                                  <i class="material-icons check-icon" *ngIf="city.id === selectedCity?.id">check</i>
                                </a>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </li>
                      <!-- Single city display (only when one city) -->
                      <li class="city-name" *ngIf="!showCitySwitcher">{{ selectedCity?.name || user.city }}</li>
                      <li class="visit-city-link" *ngIf="!showCitySwitcher">
                        <a [routerLink]="['/smart-city-profile/public-profile', getSelectedCityId()]">
                          <span [translate]="'navigation/visit-your-city'">Visit your city</span>
                        </a>
                      </li>
                      <li>
                        <a [routerLink]="['/edit/smart-city-profile', getSelectedCityId()]">
                          <i class="ion ion-ios-arrow-forward branded02 medIco"></i>
                          <span [translate]="'navigation/city-profile'" class="dropdown-user-text">City profile</span>
                          <div *ngIf="userService.isFree()" class="float-right plan-upgrade">
                            <span>{{'painel-dashboard/plan-standard' | translate}}</span>
                            <i class="material-icons">star</i>
                          </div>
                        </a>
                      </li>
                      <li>
                        <a [routerLink]="['/smart-city-indicators', getSelectedCityId()]">
                          <i class="ion ion-ios-arrow-forward branded02 medIco"></i>
                          <span [translate]="'navigation/indicators'" class="dropdown-user-text">Indicators</span>
                          <div *ngIf="userService.isFree()" class="float-right plan-upgrade">
                            <span>{{'painel-dashboard/plan-standard' | translate}}</span>
                            <i class="material-icons">star</i>
                          </div>
                        </a>
                      </li>
                      <li>
                        <a [routerLink]="['/smart-city-roadmap', getSelectedCityId()]">
                          <i class="ion ion-ios-arrow-forward branded02 medIco"></i>
                          <span [translate]="'navigation/solutions-roadmap'" class="dropdown-user-text"></span>
                          <div *ngIf="!userService.isPremium()" class="float-right plan-upgrade">
                            <span>{{'painel-dashboard/plan-premium' | translate}}</span>
                            <i class="material-icons">star</i>
                          </div>
                        </a>
                      </li>
                      <!-- <li class="border-bottom">
                        <a [routerLink]="['/smart-city-users',user.cityId]">
                          <i class="ion ion-ios-arrow-forward branded02 medIco"></i>
                          <span class="dropdown-user-text" [translate]="'navigation/users'">Users</span>
                        </a>
                      </li> -->
                      <li>
                        <a [routerLink]="['/account']">
                          <i class="ion ion-ios-arrow-forward branded02 medIco"></i>
                          <span [translate]="'navigation/your-account'" class="dropdown-user-text">Your account</span>
                        </a>
                      </li>
                      <!-- <li>
                        <a [routerLink]="['/choose-plan']">
                          <i class="ion ion-ios-arrow-forward branded02 medIco"></i>
                          <span class="dropdown-user-text" [translate]="'navigation/upgrade-plan'">Upgrade your plan</span>
                        </a>
                      </li> -->
                    </ng-container>

                    <ng-container *ngIf="user.isSolutionProvider()">
                      <li class="city-name">{{user.propertyName}}</li>
                      <li class="visit-city-link">
                        <a [routerLink]="['/smart-cities-suppliers',user.propertyId]">
                          <span [translate]="'navigation/visit-your-company'"></span>
                        </a>
                      </li>
                      <li>
                        <a [routerLink]="['/supplier-opportunities',user.propertyId]">
                          <i class="ion ion-ios-arrow-forward branded02 medIco"></i>
                          <span [translate]="'painel-dashboard/opportunities'" class="dropdown-user-text"></span>
                          <div *ngIf="userService.isFree()" class="float-right plan-upgrade">
                            <span>{{'painel-dashboard/plan-standard' | translate}}</span>
                            <i class="material-icons">star</i>
                          </div>
                        </a>
                      </li>
                      <li>
                        <a [routerLink]="['/supplier-solutions',user.propertyId]">
                          <i class="ion ion-ios-arrow-forward branded02 medIco"></i>
                          <span [translate]="'painel-dashboard/solutions'" class="dropdown-user-text"></span>
                          <!-- <div class="float-right plan-upgrade" *ngIf="userService.isFree()">
                            <span>{{'painel-dashboard/plan-standard' | translate}}</span>
                            <i class="material-icons">star</i>
                          </div> -->
                        </a>
                      </li>
                      <li>
                        <a [routerLink]="['/edit/supplier',user.propertyId]">
                          <i class="ion ion-ios-arrow-forward branded02 medIco"></i>
                          <span [translate]="'edit-supplier/title'" class="dropdown-user-text"></span>
                          <!-- <div class="float-right plan-upgrade" *ngIf="userService.isFree()">
                            <span>{{'painel-dashboard/plan-standard' | translate}}</span>
                            <i class="material-icons">star</i>
                          </div> -->
                        </a>
                      </li>
                      <!-- <li class="border-bottom">
                        <a [routerLink]="['/smart-city-users',user.cityId]">
                          <i class="ion ion-ios-arrow-forward branded02 medIco"></i>
                          <span class="dropdown-user-text" [translate]="'navigation/users'">Users</span>
                        </a>
                      </li> -->
                      <li>
                        <a [routerLink]="['/account']">
                          <i class="ion ion-ios-arrow-forward branded02 medIco"></i>
                          <span [translate]="'navigation/your-account'" class="dropdown-user-text">Your account</span>
                        </a>
                      </li>
                      <!-- <li>
                        <a [routerLink]="['/choose-plan']">
                          <i class="ion ion-ios-arrow-forward branded02 medIco"></i>
                          <span class="dropdown-user-text" [translate]="'navigation/upgrade-plan'">Upgrade your
                            plan</span>
                        </a>
                      </li> -->
                    </ng-container>
                    <ng-container *ngIf="isAdmin()">
                      <li>
                        <a [routerLink]="['/painel']">
                          <i class="ion ion-ios-arrow-forward branded02 medIco"></i>
                          <span [translate]="'navigation/admin'" class="dropdown-user-text"></span>
                        </a>
                      </li>
                    </ng-container>
                    <li>
                      <a (click)="logoutUser()">
                        <i class="ion ion-ios-arrow-forward branded02 medIco"></i>
                        <span [translate]="'navigation/sign-out'" class="dropdown-user-text">Sign out</span>
                      </a>
                    </li>
                  </ul>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </nav>
    </div>
  </div>
  <!-- menu lateral --desativado -->
  <div [ngClass]="{'show': showMenu}" class="collapse navbar-collapse menu-mobile" id="navbarNav">
    <div class="row mb-5">
      <div class="col-8">
        <img alt="homepage" class="dark-logo" src="../assets/images/logowhite-upgrade.svg"/>
      </div>
      <div class="col-4 text-right">
        <button (click)="menuToggle()" aria-expanded="false" aria-label="Toggle navigation" class="navbar-toggler"
                type="button">
          <i class="fal fa-times"></i>
        </button>
      </div>
    </div>
    <ul class="navbar-nav mb-5">
      <li *ngIf="loggedIn" class="nav-item dropdown">
        <a aria-expanded="false" aria-haspopup="true"
           class="nav-link nav-link-username dropdown-toggle waves-effect waves-dark" data-toggle="dropdown">
            <i class="ion ion-ios-person i24 white"></i> <span
                [innerHTML]="'navigation/hello' | translate:{value: user.firstName}">Hello,
            {{user.firstName}}</span>
            <i class="ion-ios-arrow-down medIco white"></i>
        </a>
        <div class="dropdown-menu dropdown-menu-right animated dropdown-user-container">
            <ul class="dropdown-user">
                <ng-container *ngIf="isAdmin()">
                    <li>
                        <a [routerLink]="['/painel']">
                            <i class="ion ion-ios-arrow-forward branded02 medIco"></i>
                            <span [translate]="'navigation/admin'" class="dropdown-user-text"></span>
                        </a>
                    </li>
                </ng-container>
                <li>
                    <a (click)="logoutUser()">
                        <i class="ion ion-ios-arrow-forward branded02 medIco"></i>
                        <span [translate]="'navigation/sign-out'" class="dropdown-user-text">Sign out</span>
                    </a>
                </li>
            </ul>
        </div>
      </li>
      <li class="nav-item active">
        <a (click)="menuToggle()" [routerLink]="['/about-us']" [translate]="'navigation/about-us'" class="nav-link"
           routerLinkActive="router-link-active">Quem Somos</a>
      </li>
      <li class="nav-item">
        <a (click)="menuToggle()" [routerLink]="['/cities-diagnosis']" [translate]="'navigation/cities-diagnosis'"
           class="nav-link"
           routerLinkActive="router-link-active">Diagnóstico de Cidades</a>
      </li>
      <li class="nav-item">
        <a (click)="menuToggle()" class="nav-link" routerLinkActive="router-link-active">{{'navigation/solutions-marketplace' | translate}}</a>
        <ul class="navbar-nav submenu">
          <li class="nav-item">
            <a (click)="menuToggle()" [routerLink]="['/smart-cities-solutions']"
               class="nav-link">{{'navigation/access-the-marketplace' | translate}}</a>
          </li>
          <li class="nav-item">
            <a (click)="menuToggle()" [routerLink]="['/solution-marketplace']"
               class="nav-link">{{'navigation/about-marketplace' | translate}}</a>
          </li>
        </ul>
      </li>
      <li class="nav-item">
        <a (click)="menuToggle()" [routerLink]="['/our-services']" class="nav-link"
           routerLinkActive="router-link-active">{{'navigation/our-services' | translate}} </a>
        <ul class="navbar-nav submenu">
            <li class="nav-item">
                <a (click)="menuToggle()" [routerLink]="['/our-services', 'public-administrator']"
                   class="nav-link">{{'create-account/PUBLIC_ADMINISTRATOR' | translate}}
                </a>
            </li>
            <li class="nav-item">
                <a (click)="menuToggle()" [routerLink]="['/our-services', 'solution-provider']"
                   class="nav-link">{{'our-services/solution-provider' | translate}}
                </a>
            </li>
            <li class="nav-item">
                <a (click)="menuToggle()" [routerLink]="['/our-services', 'private-organization']"
                   class="nav-link">{{'landing/public-private' | translate}}
                </a>
            </li>
            <li class="nav-item">
                <a (click)="menuToggle()" [routerLink]="['/our-services', 'connected-citizen']"
                   class="nav-link">{{'our-services/connected-citizens' | translate}}
                </a>
            </li>
        </ul>
      </li>
      <li class="nav-item">
        <a [translate]="'navigation/blog'" class="nav-link"
           href="https://blog.brightcities.city{{ (language.current().flag == 'us') ? '' : '/pt-br/' }}">Blog</a>
      </li>
      <li class="nav-item">
        <a (click)="menuToggle()" [routerLink]="['/certification']" [translate]="'navigation/certification'"
           class="nav-link"
           routerLinkActive="router-link-active">Certificação</a>
      </li>
      <li class="nav-item">
        <a (click)="menuToggle()" [routerLink]="['/faq']"
           class="nav-link">FAQ</a>
      </li>
      <li class="nav-item">
          <a [translate]="'navigation/rankings'" class="nav-link">Rankings&nbsp;</a>
          <ul class="navbar-nav submenu">
              <li class="nav-item">
                  <a (click)="menuToggle()" class="nav-link"
                     href="https://blog.brightcities.city{{ (language.current().flag == 'us') ? '/ranking-cidades-sustentaveis-2026/' : '/pt-br/ranking-cidades-sustentaveis-2026/' }}">2026</a>
              </li>
              <li class="nav-item">
                  <a (click)="menuToggle()" class="nav-link"
                     href="https://blog.brightcities.city{{ (language.current().flag == 'us') ? '/ranking-de-cidades-sustentaveis-2025/' : '/pt-br/ranking-de-cidades-sustentaveis-2025/' }}">2025</a>
              </li>
              <li class="nav-item">
                  <a (click)="menuToggle()" class="nav-link"
                     href="https://blog.brightcities.city{{ (language.current().flag == 'us') ? '/ranking-de-cidades-sustentaveis-2024/' : '/pt-br/ranking-de-cidades-sustentaveis-2024/' }}">2024</a>
              </li>
              <li class="nav-item">
                  <a (click)="menuToggle()" class="nav-link"
                     href="https://blog.brightcities.city{{ (language.current().flag == 'us') ? '/ranking-bright-cities-2023/' : '/pt-br/ranking-bright-cities-2023/' }}">2023</a>
              </li>
          </ul>
      </li>
      <li *ngIf="loggedIn" class="nav-item-language d-block">
        <button class="language-box">
          <span (click)="changeLanguage(i, lang.flag)" *ngFor="let lang of languages; let i = index"
                ngClass="flag-icon flag-icon-{{ lang.flag }}"></span>
        </button>
    </li>
    </ul>
    <ul *ngIf="!loggedIn" class="navbar-nav login-buttons">
      <li class="nav-item">
        <a (click)="onLogin(); menuToggle()" [translate]="'navigation/login'" class="nav-link login">Login</a>
      </li>
      <li class="nav-item">
        <a [routerLink]="['/create-account']" [translate]="'navigation/register'" class="btnWhite">Register</a>
      </li>
      <li class="nav-item-language">
        <button class="language-box">
          <span (click)="changeLanguage(i, lang.flag)" *ngFor="let lang of languages; let i = index"
                ngClass="flag-icon flag-icon-{{ lang.flag }}"></span>
        </button>
      </li>
    </ul>
  </div>
</header>
<!-- ============================================================== -->
<!-- End Topbar header -->
<!-- ============================================================== -->
